module.exports = __webpack_public_path__ + "img/324-e73996.png";